import React from 'react';
import Btn, { btnTypes } from '../btn';
import BaseError from '../BaseError';

const FetchError = ({
  text = 'Ошибка при получении данных',
  refetch,
  actionSlot,
}) => {
  return (
    <BaseError description={createDescription(text)}>
      {typeof refetch === 'function' && (
        <Btn type={btnTypes.primary} onClick={refetch}>
          Попробовать снова
        </Btn>
      )}
      {actionSlot}
    </BaseError>
  );
};

export default FetchError;

function createDescription(text) {
  return (
    <>
      {text}
      <br />
      Если это не первая попытка получить данные, обратитесь в службу поддержки
    </>
  );
}
